import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Paper from 'components/Paper'
import useViewport from 'hooks/useViewport'

import KeyFeatures from './components/KeyFeatures'
import Pricing from './components/Pricing'
import ProductInfo from './components/ProductInfo'
import Snippets from './components/Snippets'

import classes from './BestProductCard.module.scss'

/** @type {import("./types").default} */
const BestProductCard = ({ hasDemoForm, listing, isFirstCard, facet, onShowPricingModal, position = 0, ...props }) => {
  const { is, up } = useViewport()
  const isMobile = is('xs')
  const isDesktop = up('lg')
  const hasKeyFeatures = isDesktop

  const onClickPricing = () => onShowPricingModal({ pGuid: listing.global_product_id })

  return (
    <Grid container component={Paper} className={clsx('BestProductCard', classes.root)} {...props}>
      <Grid item xs={12} sm={8} lg={9}>
        <ProductInfo
          hasKeyFeatures={hasKeyFeatures}
          listing={listing}
          isFirstCard={isFirstCard}
          facet={facet}
          listingPosition={position}
        />
      </Grid>

      {!isMobile && (
        <Grid item xs={12} sm={4} lg={3}>
          <Pricing hasDemoForm={hasDemoForm} listing={listing} onClickPricing={onClickPricing} position={position} />
        </Grid>
      )}
      {!isDesktop && (
        <>
          <div className={classes.divider} />
          <Grid item xs={12}>
            <KeyFeatures listing={listing} isFirstCard={isFirstCard} />
          </Grid>
        </>
      )}
      <div className={classes.divider} />
      <Grid item xs={12}>
        <Snippets listing={listing} isFirstCard={isFirstCard} />
      </Grid>
      <div className={classes.divider} />
      {isMobile && (
        <Grid item xs={12}>
          <Pricing hasDemoForm={hasDemoForm} listing={listing} onClickPricing={onClickPricing} position={position} />
        </Grid>
      )}
    </Grid>
  )
}

export default BestProductCard
